import { defineMessages } from 'react-intl-next';

export const i18n: {
	archivedAndPendingComponents: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	archivedAndPendingComponents: {
		id: 'search-page.filters.names.archivedAndPendingComponents',
		defaultMessage: 'Show archived/pending components',
		description: 'Label for filtering by archived and pending components',
	},
});
